<div matTooltip="Equipment: {{value}}">
    <div *ngIf="exists" style="background-color: rgb(192, 64, 64); height: 24px; width: 12px">&nbsp;</div>
    <div *ngIf="!exists" style="background-color: rgb(234, 191, 191); height: 24px; width: 12px">&nbsp;</div>
</div>

